<template>
  <div>
     <svg width="36" height="36" @click="showFilter" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
     <title>Filter</title>

<path d="M11.4982 12C11.1047 12 10.8861 12.4682 11.0609 12.7959L16.4825 20.5676V26.4666C16.4825 26.8879 16.8759 27.122 17.2257 26.9347L19.2369 25.8579C19.4118 25.7643 19.4993 25.577 19.4993 25.3898V20.5676L24.9208 12.7959C25.1394 12.4214 24.877 12 24.4835 12H11.4982Z" stroke="#3D56E6" stroke-miterlimit="10"/>
<defs>
<filter id="filter0_d" x="0" y="0" width="36" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
<feOffset/>
<feGaussianBlur stdDeviation="1.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
</filter>
</defs>
</svg>
    <!-- <v-icon title="Filter" small class="icon--text" @click="showFilter">fas fa-filter</v-icon> -->
    <!-- <v-dialog
        v-model="filterDrawer"
    max-width="900px">-->
    <v-navigation-drawer
      temporary
      v-model="filterDrawer"
      right
      width="900"
      hide-overlay
      fixed
      app
      left
      :clipped="$vuetify.breakpoint.lgAndUp"
    >
      <v-card v-if="showFilter">
        <v-card-title class="body-1">
          <strong>Select filter</strong>
          <v-spacer />
          <!-- <v-text-field
            v-model="save"
            append-icon="save"
            label="Filter Name"
            class="grey--text"
            color="black"
            single-line
          ></v-text-field> -->
          <v-spacer />
          <v-btn v-if="false" small outline @click="saveFilter">
            <v-icon small>fas fa-save</v-icon>Save
          </v-btn>&nbsp;
           <v-btn
            small
            outline
            style="zoom:99%"
            color="indigo"
            @click="applyFilter"
          >
            <v-icon small class="indigo--text" >fas fa-check-cirlce</v-icon>Apply
          </v-btn>
           <v-icon small class="indigo--text" @click="filterDrawer = false">close</v-icon>
        </v-card-title>
        <v-layout row wrap>
          <v-flex xs3 md3 sm3>
            <v-list class="pa-0" style="border-left:2px solid orange">
              <v-divider />
              <v-list-tile>
                <v-list-tile-title class="caption grey--text" style="font-size:12px">
                  <strong>
                    <v-icon small flat class="grey--text">fas fa-filter</v-icon>Saved Filters
                  </strong>
                  <v-spacer />
                  <span class="text-xs-right">
                    <v-icon small flat class="grey--text">fas fa-save</v-icon>
                  </span>
                </v-list-tile-title>
              </v-list-tile>
              <v-divider />
              <template v-for="f in savedFilters">
                <v-list-tile @click="showFilters(f)">
                  <v-list-tile-title style="font-size:12px">{{f.name}}</v-list-tile-title>
                </v-list-tile>
              </template>
               <v-list-tile>
                  <v-text-field
                    v-model="save"
                    single-line
                    hide-details
                    outline
                    class="grey--text"
                    color="black"
                    append-icon="fas fa-save"
                    @click:append="saveFilter"
                  ></v-text-field>
                </v-list-tile>
            </v-list>
          </v-flex>
          <v-flex xs9 md9 sm9>
            <FilterComponent :filters="filters" />
          </v-flex>
        </v-layout>
        <v-card-actions></v-card-actions>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>
<script>
import FilterComponent from "@/components/FilterComponent.vue";
import FilterModel from "@/api/service/FilterService.js";
export default {
  props: ["filterData2", "filterKey"],
  components: {
    FilterComponent
  },
  data() {
    return {
      options: [],
      filterDrawer: false,
      conditions: {},
      savedFilters: [],
      save: [],
      filterData: {},
      Filter: {},
      filters: {}
    };
  },
  created:async  function() {
    await this.getFilters();
     await this.getSavedFilters();
  },
  mounted: function() {},
  computed: {},
  methods: {
     getSavedFilters() {
      FilterModel.findAll({ key_type: this.filterKey, template: 0 })
        .then(($options) => this.setSavedFilters($options))
        .catch((error) => console.log(error));
    },
    setSavedFilters($filters) {
      this.savedFilters = $filters;
    },
    showFilter() {
      this.filterDrawer = true;
    },
    getFilters() {
      FilterModel.findAll({ key_type: this.filterKey, template: 1 })
        .then(($options) => this.setData($options))
        .catch((error) => console.log(error));
    },
    showFilters($filter) {
      var $keys;
      //alert(JSON.stringify($filter))
      this.filters = JSON.parse($filter);
      var $filter = $filter.filter[0];
      if ($filter) {
        $keys = Object.keys($filter);
        var $i = 0;
        for ($i = 0; $i < $keys.length; $i++) {
          this.filters[$keys[$i]].default = $filter[$keys[$i]];
        }
      }
      //this.filters.Active.default=1;
    },
    applyFilter() {
      var $i = 0;
      var $conditions = [];
      var $keys = Object.keys(this.filters);
      for ($i = 0; $i < $keys.length; $i++) {
        if (this.filters[$keys[$i]].default) {
          var $j = {};
          this.conditions[$keys[$i]] = this.filters[$keys[$i]].default;
        }
      }
      this.$emit("applyFilter", this.conditions);
      this.filterDrawer = false;
    },
    setData($options) {
      this.filterData = JSON.parse($options[0].filters);
      this.filters = this.filterData;
      this.setData1(this.filters);
    },
    setData1($options) {
      var $i = 0;
      for ($i = 0; $i < $options.length; $i++) {
        this.savedFilters.push({
          id: $options[$i].id,
          name: $options[$i].name,
          filters: [JSON.parse($options[$i].filters)],
        });
      }
    },
    saveFilter() {
      var navigate = this.$router;
      var stores = this.$store;
      var $i = 0;
      var $conditions = [];
      var $keys = Object.keys(this.filters);
      for ($i = 0; $i < $keys.length; $i++) {
        if (this.filters[$keys[$i]].default) {
          var $j = {};
          this.conditions[$keys[$i]] = this.filters[$keys[$i]].default;
        }
      }
      this.Filter.filters = JSON.stringify(this.conditions);
      this.Filter.template = 0;
      this.Filter.name = this.save;
      this.Filter.key_type = this.filterKey;
      FilterModel.saveFilters(this.Filter)
        .then(response => {
          this.filterDrawer = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>   